import React from 'react';
import { State, UserProfile } from '@uplift/api';
import { getFormattedAddressParts } from '@uplift/utils';
import { EditableSectionRow } from '../../../../EditableSection';
import { LoadableTypography } from '../../../../LoadableTypography';
import { SettingsAddressForm } from './SettingsAddressForm';
import { useL10n } from '@uplift/hooks';


export type AddressSettingsRowProps = {
  isLoading?: boolean;
  profile?: UserProfile;
  states?: State[];

  rowKey: string;
};


export const AddressSettingsRow: React.FC<AddressSettingsRowProps> = ({ isLoading, profile, states, ...props }) => {
  const l10n = useL10n();

  const addressParts = getFormattedAddressParts(
    {
      address1: profile?.address?.line1 ?? '',
      address2: profile?.address?.line2 ?? '',
      city: profile?.address?.city ?? '',
      zip: profile?.address?.zip ?? ''
    },
    (states ?? []).find((state) => state.id === profile?.address?.stateId),
    { stateName: 'fullName' }
  );

  return (
    <EditableSectionRow
      label={l10n.providerSettings.homeAddress}
      form={<SettingsAddressForm states={states ?? []} />}
      kind="editable-row"
      {...props}
    >
      <div>
        <LoadableTypography
          style={{ fontWeight: 500 }}
          width="140px"
          loading={isLoading}
        >
          {addressParts.address}
        </LoadableTypography>
      </div>
      <LoadableTypography
        width="140px"
        loading={isLoading}
      >
        {addressParts.addressCityState}
      </LoadableTypography>
    </EditableSectionRow>
  );
};
